import React, { useState } from 'react';
import './analises.css';
import { getS3Url } from '../../services/funcoes';
import { FiEdit2, FiTrash2 } from 'react-icons/fi';
import { HiChevronUp, HiChevronDown } from 'react-icons/hi';
// import { toast } from 'react-toastify';

const AnaliseCard = ({ data, editarAnalise, excluirAnalise }) => {
  const [expanded, setExpanded] = useState(false);

  const toggle = () => setExpanded(!expanded);

  return (
    <div className="card">
      <div className="card-header" onClick={toggle}>
        <h3>{data.tip_compartimento}</h3>

        <button
          onClick={() => editarAnalise(data.cod_compartimento)}
          className="bg-green-600 text-green px-4 py-2 rounded hover:bg-green-700 transition"
        >
          <FiEdit2 size={20} color="green" />
        </button>
        <button
          onClick={() => excluirAnalise(data.cod_compartimento)}
          className="bg-green-600 text-green px-4 py-2 rounded hover:bg-green-700 transition"
        >
          <FiTrash2 size={20} color="green" />
        </button>

        {/* <span className="toggle-icon">{expanded ? '−' : '+'}</span> */}
        <span className="toggle-icon">{expanded ? <HiChevronUp /> : <HiChevronDown />}</span>
      </div>

      {expanded && (
        <div className="card-details">
          <p><strong>Data e Hora Inicial:</strong> {data.dat_horinicial}</p>
          <p><strong>ISO 4406 Inicial:</strong> {data.res_inianalise}</p>
          <p><strong>NAS 1638 Inicial:</strong> {data.res_nasinicial}</p>
          <p><strong>Crepitação Inicial:</strong> {data.idt_creinicial}</p>

          {data.idt_fotinicial && (
            <img src={getS3Url(data.idt_fotinicial)} alt="Membrana Inicial" />
          )}

          <p><strong>Data e Hora Final:</strong> {data.dat_horfinal}</p>
          <p><strong>ISO 4406 Final:</strong> {data.res_fimanalise}</p>
          <p><strong>NAS 1638 Final:</strong> {data.res_nasfinal}</p> 
          <p><strong>Crepitação Final:</strong> {data.idt_crefinal}</p>

          {data.idt_fotfinal && (
            <img src={getS3Url(data.idt_fotfinal)} alt="Membrana Final" />
          )}

          {data.idt_fotbujao && (
            <img src={getS3Url(data.idt_fotbujao)} alt="Membrana Final" />
          )}

          {data.idt_fotfiltro && (
            <img src={getS3Url(data.idt_fotfiltro)} alt="Membrana Final" />
          )}

          <p><strong>Observação:</strong> {data.obs_analise}</p>

        </div>
      )}
    </div>
  );
};

export default AnaliseCard;